export default "__VITE_ASSET__BpMvIaXd__"